"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const helpers_1 = require("../../utils/helpers");
const Container_1 = __importDefault(require("../Container/Container"));
const Layout_1 = require("../../Layout");
const Svgs_1 = require("../../Svgs");
require("./index.css");
require("../../global.css");
const BaseContainer = (props) => {
    const [mobile, setMobile] = React.useState(false);
    const [showMobileMenu, setShowMobileMenu] = React.useState(false);
    React.useEffect(() => {
        debouncedHandleResize();
        window.addEventListener("resize", debouncedHandleResize);
        return () => window.removeEventListener("resize", debouncedHandleResize);
    });
    const debouncedHandleResize = (0, helpers_1.debounce)(() => {
        if (window.innerWidth < 1024) {
            setMobile(true);
        }
        else {
            setMobile(false);
        }
    }, 500);
    const { children, headerMenu } = props;
    const renderMobileMenu = () => {
        const { mobileHeaderMenu } = props;
        return (React.createElement("div", { className: "base_container_mobile_menu" }, mobileHeaderMenu ? mobileHeaderMenu : headerMenu));
    };
    const renderMobileHeader = () => {
        const MOBILE_SVG_DIMENSIONS = 75;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "base_container_header_content" },
                React.createElement(Container_1.default, { width: "50%" },
                    React.createElement("div", { className: "base_container_mobile_icons" },
                        React.createElement(Svgs_1.BurgerMenu, { height: MOBILE_SVG_DIMENSIONS, width: MOBILE_SVG_DIMENSIONS, onClick: () => setShowMobileMenu(!showMobileMenu) }),
                        React.createElement(Svgs_1.BiomemeIcon, { height: MOBILE_SVG_DIMENSIONS, width: MOBILE_SVG_DIMENSIONS })))),
            showMobileMenu && renderMobileMenu(),
            React.createElement(Layout_1.Divider, { classes: "base_container_divider_mobile" })));
    };
    const renderDefaultHeader = () => {
        const { logoOnClick } = props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "base_container_header_content" },
                React.createElement("div", { onClick: logoOnClick ? () => logoOnClick() : () => null },
                    React.createElement(Svgs_1.BiomemeLogo, null)),
                headerMenu),
            React.createElement(Layout_1.Divider, { classes: "base_container_divider" })));
    };
    const { sticky } = props;
    return (React.createElement("div", { className: "base_container" },
        React.createElement("header", { className: sticky
                ? "base_container_header base_container_header_sticky"
                : "base_container_header" }, mobile ? renderMobileHeader() : renderDefaultHeader()),
        React.createElement("div", { className: "base_container_content" }, children)));
};
exports.default = BaseContainer;
//# sourceMappingURL=BaseContainer.js.map